module.exports = __webpack_public_path__ + "static/img/nekker3.3dd2c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/nekker3.png
// module id = fGvZ
// module chunks = 0